"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropTypesMeta = exports.PropTypesInput = exports.PropTypesOption = exports.PropTypesRef = exports.ValueSetPropTypes = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
exports.ValueSetPropTypes = prop_types_1.default.shape({
    url: prop_types_1.default.string,
    expansion: prop_types_1.default.shape({
        contains: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            system: prop_types_1.default.string,
            display: prop_types_1.default.string,
            code: prop_types_1.default.string,
            version: prop_types_1.default.string,
        })),
    }),
});
exports.PropTypesRef = prop_types_1.default.oneOfType([
    prop_types_1.default.func,
    prop_types_1.default.shape({
        // eslint-disable-next-line react/forbid-prop-types
        current: prop_types_1.default.any,
    }),
]);
// export const selectOptionsPropTypes = PropTypes.arrayOf(
exports.PropTypesOption = prop_types_1.default.shape({
    value: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.string.isRequired,
});
exports.PropTypesInput = prop_types_1.default.shape({
    // eslint-disable-next-line react/forbid-prop-types
    value: prop_types_1.default.any,
    onChange: prop_types_1.default.func,
});
exports.PropTypesMeta = prop_types_1.default.shape({
    error: prop_types_1.default.string,
    formulaError: prop_types_1.default.shape({
        message: prop_types_1.default.string,
    }),
    touched: prop_types_1.default.bool,
    submitFailed: prop_types_1.default.bool,
});
//# sourceMappingURL=propTypes.js.map